// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_group.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppUser } from "./app_user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * The AppGroup message.
 *
 * @generated from protobuf message c1.api.app.v1.AppGroup
 */
export interface AppGroup {
    /**
     * The app referenced by this group.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The id field.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The time in RFC3339 format of when the app group was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The time in RFC3339 format of when the app group was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The time in RFC3339 format of when the app group was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the group in the app.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppGroupRequest
 */
export interface CreateAppGroupRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateAppGroupRequest
 */
export interface UpdateAppGroupRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppGroup group = 1;
     */
    group?: AppGroup;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppGroupRequest
 */
export interface GetAppGroupRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppGroupRequest
 */
export interface DeleteAppGroupRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppGroupsRequest
 */
export interface ListAppGroupsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppGroupsResponse
 */
export interface ListAppGroupsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppGroup list = 1;
     */
    list: AppGroup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppGroupUsersRequest
 */
export interface ListAppGroupUsersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppGroupUsersResponse
 */
export interface ListAppGroupUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUser list = 1;
     */
    list: AppUser[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppGroup$Type extends MessageType<AppGroup> {
    constructor() {
        super("c1.api.app.v1.AppGroup", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppGroup
 */
export const AppGroup = new AppGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppGroupRequest$Type extends MessageType<CreateAppGroupRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppGroupRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppGroupRequest
 */
export const CreateAppGroupRequest = new CreateAppGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppGroupRequest$Type extends MessageType<UpdateAppGroupRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppGroupRequest", [
            { no: 1, name: "group", kind: "message", T: () => AppGroup, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppGroupRequest
 */
export const UpdateAppGroupRequest = new UpdateAppGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppGroupRequest$Type extends MessageType<GetAppGroupRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppGroupRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppGroupRequest
 */
export const GetAppGroupRequest = new GetAppGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppGroupRequest$Type extends MessageType<DeleteAppGroupRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppGroupRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppGroupRequest
 */
export const DeleteAppGroupRequest = new DeleteAppGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppGroupsRequest$Type extends MessageType<ListAppGroupsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppGroupsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppGroupsRequest
 */
export const ListAppGroupsRequest = new ListAppGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppGroupsResponse$Type extends MessageType<ListAppGroupsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppGroupsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppGroup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppGroupsResponse
 */
export const ListAppGroupsResponse = new ListAppGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppGroupUsersRequest$Type extends MessageType<ListAppGroupUsersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppGroupUsersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppGroupUsersRequest
 */
export const ListAppGroupUsersRequest = new ListAppGroupUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppGroupUsersResponse$Type extends MessageType<ListAppGroupUsersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppGroupUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUser },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppGroupUsersResponse
 */
export const ListAppGroupUsersResponse = new ListAppGroupUsersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppGroups
 */
export const AppGroups = new ServiceType("c1.api.app.v1.AppGroups", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetAppGroupRequest, O: AppGroup },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListAppGroupsRequest, O: ListAppGroupsResponse },
    { name: "ListUsers", options: { "authz.method": { role: "VIEWER" } }, I: ListAppGroupUsersRequest, O: ListAppGroupUsersResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: CreateAppGroupRequest, O: AppGroup },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateAppGroupRequest, O: AppGroup },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: DeleteAppGroupRequest, O: Empty }
]);
